import { Navigate } from 'react-router-dom';
import { useAuth } from '../app/hooks/useAuth';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, session, isLoading } = useAuth();
  
  // Check if we're still loading authentication state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#ff8c42]"></div>
      </div>
    );
  }
  
  // If there's no session or user, redirect to login
  if (!session || !user) {
    console.log("No authenticated session, redirecting to /connect");
    return <Navigate to="/connect" replace />;
  }
  
  // User is authenticated, render children
  return <>{children}</>;
};

export default ProtectedRoute;